import { render, staticRenderFns } from "./sensorSuggest.vue?vue&type=template&id=5972cde4&"
import script from "./sensorSuggest.vue?vue&type=script&lang=ts&"
export * from "./sensorSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./sensorSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports